import { LocationPermissionHandler } from "../components/shared/component/LocationPermissionHandler";
import { reverseGeocodingService } from "../components/shared/services/reverseGeocoding.service";
import { secureStoreService } from "../components/shared/services/secure-store.service";
import { DefaultLocation } from "../types/user";

class DefaultLocationService {
  async getSetDefaultLocation(): Promise<DefaultLocation | null> {
    try {
      console.log("getSetDefaultLocation called");
      // Check if default location is already stored
      const storedLocation = await secureStoreService.getDefaultLocation();
      if (storedLocation) {
        console.log("[DefaultLocationService] Using stored default location");
        return storedLocation;
      }

      // If no stored location, fetch current location
      const result = await LocationPermissionHandler.getCurrentLocation();
      if (result.status === "granted" && result.coordinates) {
        const address = await reverseGeocodingService.getAddressAPI(
          result.coordinates
        );

        // Create default location object
        const defaultLocation: DefaultLocation = {
          coordinates: result.coordinates,
          address: address,
          addressName: "home",
        };

        // Store the fetched location as the default location
        await secureStoreService.setDefaultLocation(defaultLocation);
        console.log("[DefaultLocationService] Default location set and stored");
        return defaultLocation;
      }

      console.log(
        "[DefaultLocationService] Unable to fetch default location. result: ",
        result
      );
      return null;
    } catch (error) {
      console.error("[DefaultLocationService] Error:", error);
      return null;
    }
  }
}

export const defaultLocationService = new DefaultLocationService();
